<template>
  <CardContent
    v-if="hasChildren"
    theme="neutral-50"
    aspect="square"
    stroke="s"
    variant="outlined"
  >
    <h4>{{ box.title }}</h4>
    <ul>
      <li v-for="child in box.children" :key="child.name">
        <DialogSettingsPreferencesBoxButton
          v-if="child.type === 'box'"
          :box="child"
        />

        <DialogSettingsPreferencesBoxCheck v-else :preference="child" />
      </li>
    </ul>
  </CardContent>
</template>
<script setup lang="ts">
interface Props {
  box: any;
}

const props = defineProps({
  box: null
});

const hasChildren = computed(() => {
  const getChildren = (box, children = []) => {
    if (box.children) {
      box.children.forEach((child) => {
        getChildren(child, children);
      });
    } else {
      children.push(box);
    }
    return children;
  };
  const children = getChildren(props.box);
  return children.length > 0;
});
</script>
<style lang="scss" scoped>
h4 {
  @include font('m', 800);
}
ul {
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  gap: var(--gap_xs);
}
</style>
